module.exports = __webpack_public_path__ + "img/3 手机.9e1c2c8c.png";